/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum MarkupPriority {
    Default = 'Default',
    P100 = 'P100',
    P150 = 'P150',
    P200 = 'P200',
    P250 = 'P250',
    P300 = 'P300',
    P350 = 'P350',
    P400 = 'P400',
    P450 = 'P450',
    P500 = 'P500',
    P550 = 'P550',
    P600 = 'P600',
    P650 = 'P650',
    P700 = 'P700',
    P750 = 'P750'
}

export function MarkupPriorityFromJSON(json: any): MarkupPriority {
    return MarkupPriorityFromJSONTyped(json, false);
}

export function MarkupPriorityFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarkupPriority {
    return json as MarkupPriority;
}

export function MarkupPriorityToJSON(value?: MarkupPriority | null): any {
    return value as any;
}

